import { ModelRow } from "@mcleod/core";
import { TableRowDisplayEvent } from "@mcleod/components";
import { FilterPanel, SecondaryFilterProps } from "@mcleod/dispatch";
import { DriverSettlementTabLayout } from "./DriverSettlement";
import { OrderPayablesUtil } from "../OrderPayablesUtil";
import { AutogenLayoutDriverSettlementHold } from "./autogen/AutogenLayoutDriverSettlementHold";
import { RowDriverSettlementProfile } from "../../driver-settlement/src/models/ModelDriverSettlementProfile";

export class DriverSettlementHold extends AutogenLayoutDriverSettlementHold implements DriverSettlementTabLayout {
    public getProfileRow: () => RowDriverSettlementProfile;
    public filterPanel: FilterPanel;

    onLoad(): void | Promise<void> {
        this.filterPanel = new FilterPanel([], this.tableDriverSettlement, this.panelTaskFilters);
        this.tableDriverSettlement.addRowDisplayListener((event: TableRowDisplayEvent) => this.tableDriverSettlementOnRowDisplay(event));
    }

    getLayoutBaseFilter(row: ModelRow): boolean {
        return row.get("ready_to_pay_flag") == "N" && !row.isNull("back_office_reason_code");
    }

    tableDriverSettlementOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        tableRow.forEveryChildComponent((component) => {
            OrderPayablesUtil.setTooltipContent(component, tableRow.data);
        });
        OrderPayablesUtil.setComponentDetails({
            tableRow: tableRow,
            profileRow: this.getProfileRow()
        });
    }

    removeDynamicTaskFilters(): void {
        for (const filter of this.filterPanel.filters) {
            if (filter.dynamic) {
                this.filterPanel.removeFilterFromPanel(filter);
            }
        }
    }

    refreshDynamicTaskFilters(): SecondaryFilterProps[] {
        const activeFilter = this.filterPanel.getActiveFilter();
        this.removeDynamicTaskFilters();
        const uniqueReasonCodes: Map<string, string> = new Map();
        for (const tableRow of this.tableDriverSettlement.allRows) {
            const modelRow = tableRow.data as ModelRow;
            if (this.getLayoutBaseFilter(modelRow)) {
                uniqueReasonCodes.set(modelRow.get("back_office_reason_code"), modelRow.get("back_office_reason_descr"));
            }
        }
        for (const [reasonCode, reasonDesc] of uniqueReasonCodes) {
            const filter: SecondaryFilterProps = {
                id: reasonCode,
                caption: reasonDesc,
                filter: (row: ModelRow) => {
                    return row.get("back_office_reason_code") == reasonCode;
                },
                dynamic: true
            };
            this.filterPanel.addFilter(filter);
            if (activeFilter != null && activeFilter.id == reasonCode) {
                this.filterPanel.toggleFilterById(filter.id);
            }
        }
        if (activeFilter != null && !uniqueReasonCodes.has(activeFilter.id)) {
            this.filterPanel.applyRemoveFilter(activeFilter);
        }
        return this.filterPanel.filters.filter(f => f.dynamic);
    }
}
